<template>
  <v-footer
    ref="section-contact"
    class="pba-footer pba-text-footer pba-subtitle--text"
  >
    <v-container
      id="footer" class="d-flex flex-column flex-nowrap align-stretch"
    >
      <v-row no-gutters class="align-center justify-space-between">
        <v-col cols="12" lg="6" class="pba-footer-info d-flex flex-column align-center align-lg-start">
          <img
            :src="website_data.profile.hotel_logo"
            class="pba-logo"
          >
          <div class="pba-footer-body mt-7 mt-lg-3 text-center text-lg-start" v-html="website_data.profile.text_footer" />
          <div class="d-flex mx-n2 mt-8">
            <v-btn
              v-for="({ socmed_name, socmed_link }) in website_data.socmed" :key="socmed_name"
              :small="!isMobile" fab dark elevation="0"
              :href="socmed_link"
              target="_blank" rel="noopener nofollow"
              :color="socialButtons[socmed_name].color"
              class="mx-2"
            >
              <v-icon :large="isMobile">
                {{ socialButtons[socmed_name].icon }}
              </v-icon>
            </v-btn>
          </div>
        </v-col>

        <v-col cols="12" lg="6" class="pba-footer-contact pt-9 pt-lg-0 d-flex flex-column align-center align-lg-start">
          <div class="pba-text-footer-headline pba-primary--text" v-text="label_data.MENU_CONTACT" />
          <div>
            <div v-if="website_data.profile.hotel_email" class="d-flex align-center mt-5 black--text pba-text-footer-contact">
              <v-icon class="me-5" color="black">
                mdi-email-outline
              </v-icon>
              <div>
                <div v-for="(email, i) in website_data.profile.hotel_email.split(',')" :key="i" v-text="email.trim()" />
              </div>
            </div>
            <div v-if="website_data.profile.hotel_phone" class="d-flex align-center mt-5 black--text pba-text-footer-contact">
              <v-icon class="me-5" color="black">
                mdi-phone-outline
              </v-icon>
              <div>
                <div v-for="(number, i) in website_data.profile.hotel_phone.split(',')" :key="i" v-text="number.trim()" />
              </div>
            </div>
            <div v-if="website_data.profile.hotel_address" class="d-flex align-center mt-5 black--text pba-text-footer-contact">
              <v-icon class="me-5" color="black">
                mdi-map-marker-outline
              </v-icon>
              <div>{{ website_data.profile.hotel_address }}</div>
            </div>
          </div>
        </v-col>
      </v-row>
      <div class="my-12 mb-lg-0 text-center text-lg-start">
        <div class="mb-1">
          {{ label_data.POWERED_BY || 'powered by' }}
          <a
            :href="corpLinks[website_data.profile.poweredby || 'Archipelago']"
            target="_blank" rel="noopener nofollow"
            class="text-decoration-underline pba-subtitle--text"
          >{{ website_data.profile.poweredby || 'Archipelago' }}</a>
        </div>
        <div>
          Copyright &copy; {{ new Date().getFullYear() }}
          <a
            :href="corpLinks.Archipelago"
            target="_blank" rel="noopener nofollow"
            class="text-decoration-underline pba-subtitle--text"
          >Archipelago</a>
          , All Rights Reserved
        </div>
      </div>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'HomeFooter',
  }
</script>

<style lang="sass">
  #footer a
    text-decoration: none
</style>
